import { Injectable } from '@angular/core';
import { ApiService, URLS } from 'app/services/api.service';
import { Unidades } from 'app/models/unidades';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class MapaService {

  constructor(    private apiService: ApiService,
    ) { }

    unidades : Unidades[]

   getAgentes (){
    this.apiService.get(URLS.UNIDADES.GET_UNIDADES, '', environment.urlLaravel)
    .subscribe(
      function (data) {
        console.log(data)

        return this.unidades = data;
        // let LimitesTemp: Unidades[] = Array(10)
        // for (let i: number = 0; i < data.length; i++) {
        //   LimitesTemp[i] = data[i]
        //   LimitesTemp[i].cor = "#" + data[i].cor
        //   LimitesTemp[i].checked = false
        //   for (let j: number = 0; j < data[i].paths.length; j++) {
        //     for (let m: number = 0; m < data[i].paths[j].length; m++) {
        //       LimitesTemp[i].paths[j][m].lng = +data[i].paths[j][m].lng
        //       LimitesTemp[i].paths[j][m].lat = +data[i].paths[j][m].lat
        //     }
        //   }
        // }
        // vm.unidades = LimitesTemp
      },
      function (error) {
        console.log(error);
      });

  }
}



// WEBPACK FOOTER //
// ./src/app/services/mapa.service.ts